
import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext"
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import Header from "../components/header"
import Footer from "../components/footer"
import Body from "../components/body"

import CompanyInfo from "../components/companyInfo";
import UsersCount from "../components/usersCount";
import MachinesList2 from "../components/machineList2";
import ProdList1 from "../components/prodlist";
import NewProdForm from "../components/newProdForm";
import NewBatchForm from "../components/newBatchForm";
import NewActForm from "../components/newActForm";

const NewActL = () => {

  const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));


  return (
    <>


      <div class="body">


        <h2>{t('actType9')}</h2>

        <div>

        <NewActForm/>

        </div>

      </div>



    </>
  )
}

export default NewActL;